import { c as _c } from "react/compiler-runtime";
import { getUploadImageKey } from '@onefootprint/core';
import type { DocumentImage } from '@onefootprint/request-types/dashboard';
import type { EntityVault } from '@onefootprint/types';
import { useObjectUrl } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { easeInOut, motion } from 'framer-motion';
import Image from 'next/image';
import { ROTATION_CLASS_NAME, type Rotation } from '@/utils/rotation';
type SelfiePreviewProps = {
  image: DocumentImage;
  vault: EntityVault;
  rotation?: Rotation;
};
const SelfiePreview = t0 => {
  const $ = _c(9);
  const {
    image,
    vault,
    rotation: t1
  } = t0;
  const rotation = t1 === undefined ? 0 : t1;
  const base64Data = vault[getUploadImageKey({
    image
  })] as string;
  const {
    objectUrl
  } = useObjectUrl(base64Data);
  if (!objectUrl) {
    return null;
  }
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 0,
      scale: 0.95,
      x: 50
    };
    t3 = {
      opacity: 1,
      scale: 1,
      x: 0
    };
    t4 = {
      opacity: 0,
      scale: 0.95,
      x: 50
    };
    t5 = {
      duration: 0.1,
      ease: easeInOut
    };
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
    t5 = $[3];
  }
  const t6 = ROTATION_CLASS_NAME[rotation];
  let t7;
  if ($[4] !== t6) {
    t7 = cx("object-cover w-full h-auto", t6);
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== objectUrl || $[7] !== t7) {
    t8 = <motion.div className="flex overflow-hidden fixed right-3 bottom-3 md:bottom-auto md:top-14 self-start rounded shadow-lg z-drawer size-24 md:size-56" initial={t2} animate={t3} exit={t4} transition={t5}><Image className={t7} src={objectUrl} width={600} height={600} alt="selfie preview" data-dd-privacy="mask" /></motion.div>;
    $[6] = objectUrl;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
};
export default SelfiePreview;